module.exports = __webpack_public_path__ + "img/kajo-logo_web.b446695b.svg";